<template>
    <div class="fill-blank-text-wrapper"
    :class="!disabled && answersIn && 'answering'">
      <span v-for="(segment, index) in parsedSegments" :key="index">
        <template v-if="segment.type === 'text'">
          {{ segment.value }}
        </template>
        <template v-else-if="segment.type === 'blank'">
          <b-form-input
              :disabled="disabled"
              v-model="answers[segment.value]"
              class="input"
              @blur="emitAnswers"
          />
        </template>
      </span>
    </div>
</template>

<script>
    export default {
        name: "design-2021-fill-in-the-blanks-component",
        props: {
            text: {
                type: String,
                required: false,
                default: '',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            answersIn: {
                type: Object,
                required: false,
                default: () => {},
            }
        },
        data() {
            return {
                parsedSegments: [],
                answers: this.answersIn,
            }
        },
        mounted() {
            this.parseTemplate(this.text);
            if (this.answersIn) {
                this.answers = this.answersIn;
            }
        },
        methods: {
            parseTemplate(text) {
                this.parsedSegments = []
                this.answers = {}

                const regex = /\*\*(.+?)\*\*/g
                let lastIndex = 0
                let match

                while ((match = regex.exec(text)) !== null) {
                    if (match.index > lastIndex) {
                        this.parsedSegments.push({
                            type: 'text',
                            value: text.slice(lastIndex, match.index)
                        })
                    }

                    const blankId = match[1]
                    this.parsedSegments.push({
                        type: 'blank',
                        value: blankId
                    })

                    if (!this.answers[blankId]) {
                        this.$set(this.answers, blankId, '')
                    }


                    lastIndex = regex.lastIndex
                }

                if (lastIndex < text.length) {
                    this.parsedSegments.push({
                        type: 'text',
                        value: text.slice(lastIndex)
                    })
                }
            },
            emitAnswers() {
                this.$emit('update-answer', this.answers);
            }
        },
        watch: {
            text: {
                handler(newTemplate) {
                    this.parseTemplate(newTemplate)
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    .fill-blank-text-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'eight');

        span:has(> input){
            width: 100%;
        }

        input.form-control {
            margin-bottom: 0;
            box-shadow: 0 1px 7px rgba($text-color, 11%);
            outline: solid 1px transparent;

            &:hover,
            &:focus {
                outline-color: rgba($primary, 35%);
            }
        }

        &.answering {
            input.form-control {
                background-color: $white;
            }
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'sm')) {
        .fill-blank-text-wrapper {
            span:has(> input) {
                width: auto;
            }

            input.form-control {
                width: 150px;
            }
        }
    }
</style>